import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {acceptQuotation, showAcceptQuotation} from '../../../data/followup/actions/followup';
import { getShowAcceptQuotation, getData, getIsAcceptingQuotation } from '../../../data/followup/selectors/followup';
import AcceptQuotationButton from '../../followup/components/AcceptQuotationButton';
import * as status from '../../../data/booking/constants/quotation_status';
import moment from 'moment'
import {getUser} from "../../../data/account/selectors/user";
import isEmpty from "lodash/isEmpty";
import {TooLate} from "../components/AcceptQuotationButton";

class AcceptQuotationButtonContainer extends Component {
    static propTypes = {
        data: PropTypes.object,
        isLoading: PropTypes.bool,
        shouldShowAcceptQuotation: PropTypes.bool,
        showAcceptQuotation: PropTypes.func
    };

    handleClick() {
        if (this.props.shouldShowAcceptQuotation) {
            // already active
            return;
        }

        this.props.showAcceptQuotation();
    }

    render() {
        const { shouldShowAcceptQuotation, data, isLoading, user } = this.props;

        if (null == data) {
            return null;
        }

        const noPhoneNumbers = isEmpty(user.contact.phoneNumbers)

        const hide = 'quotation' !== data.type
            || status.PENDING_CUSTOMER_CONFIRMATION !== data.status;

        if (hide) {
            return null;
        }

        if(moment(data.startAt).startOf('day').isBefore(moment())){
            return <TooLate />
        }

        return (
            <AcceptQuotationButton
                noPhoneNumbers={noPhoneNumbers}
                disabled={hide || shouldShowAcceptQuotation || isLoading || noPhoneNumbers}
                onClick={::this.handleClick}
            />
        );
    }
}

export default connect(
    state => ({
        data: getData(state.followup),
        isLoading: getIsAcceptingQuotation(state.followup),
        shouldShowAcceptQuotation: getShowAcceptQuotation(state.followup),
        user: getUser(state)
    }),
    dispatch => bindActionCreators({ showAcceptQuotation }, dispatch)
)(AcceptQuotationButtonContainer);
